import { ChevronRightIcon } from "@fluentui/react-icons-mdl2";
import { Button, Col, Form, Row } from "antd";
import { endOfDay, format, startOfDay } from "date-fns";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLazyGetProductCategoryListQuery } from "../../../redux/api/SystemApi";
import { AuctionSearch } from "../../auction/types";
import FloatDatePicker from "../../common/components/FloatDatePicker";
import FloatInput from "../../common/components/FloatInput";
import { HomeSearchState } from "../types/types";
import { ReactComponent as Expand } from '../../../assets/images/expand.svg';

interface FilterProps {
    categories: string[],
    setCategories: React.Dispatch<React.SetStateAction<string[]>>,
    setSearchDate: React.Dispatch<React.SetStateAction<string[]>>,
    setSearchName: React.Dispatch<React.SetStateAction<string>>,
    triggerSearch: (submitValue: AuctionSearch) => void,
    setPage: React.Dispatch<React.SetStateAction<number>>,
    setSearchPrice: React.Dispatch<React.SetStateAction<number[]>>,
    searchDate: string[],
    searchName: string,
    searchPrice: number[],
}

const AuctionFilter = ({ categories, setCategories, setSearchDate, setSearchName, triggerSearch, setPage, setSearchPrice,
    searchDate, searchName, searchPrice }: FilterProps) => {
    const [form] = Form.useForm();
    const [activeButton, setActiveButton] = useState(0);
    const [seeMore, setSeeMore] = useState(false);

    const [trigger, response] = useLazyGetProductCategoryListQuery();

    const location = useLocation();

    const searchState = location.state as HomeSearchState;

    useEffect(() => {
        trigger({ page: 0, size: 1000 })
    }, [trigger])

    const selectProduct = (type: string) => {
        let newCategories = [...categories];
        let newCategoryIndex = categories.findIndex(item => item === type);
        if (newCategoryIndex === -1) {
            newCategories.push(type);
        } else {
            newCategories.splice(newCategoryIndex, 1);
        }
        setCategories(newCategories);
        triggerSearch({
            ...newCategories ? { categoryCodes: newCategories } : {},
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { producName: searchName } : {},
        })
    }

    const filterButtonSelect = (startPrice: number, toPrice: number, buttonNum: number) => {
        setPage(1);
        triggerSearch({
            page: 0,
            ...startPrice >= 0 && activeButton !== buttonNum ? { startPriceBegin: startPrice } : {},
            ...toPrice >= 0 && activeButton !== buttonNum ? { startPriceTo: toPrice } : {},
            ...categories ? { categoryCodes: categories } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { productName: searchName } : {},
        })
        if (activeButton === buttonNum) {
            setActiveButton(0);
            setSearchPrice([-1, -1]);
        } else {
            setActiveButton(buttonNum);
            setSearchPrice([startPrice, toPrice]);
        }
    }

    const onReset = () => {
        setCategories([]);
        setSearchDate(["", ""]);
        setSearchName("");
        setSearchPrice([-1, -1]);
        setActiveButton(0);
        setPage(1);
        triggerSearch({
            page: 0,
        })
        form.resetFields();
    }

    const onValuesChange = (changedValues: any) => {
        let toDateValue = form.getFieldValue("toDate");
        if (changedValues.fromDate && toDateValue && changedValues.fromDate > toDateValue) {
            form.setFieldsValue({
                toDate: ""
            })
        }
    }

    const onFinish = (values: any) => {
        setSearchDate([
            ...values.fromDate ? [format(startOfDay(values.fromDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")] : [],
            ...values.toDate ? [format(endOfDay(values.toDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")] : [],
        ])
        setSearchName(values.name || "")
        triggerSearch({
            ...values.fromDate ? { fromDate: format(startOfDay(values.fromDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.toDate ? { toDate: format(endOfDay(values.toDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.name ? { productName: values.name } : {},
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...categories ? { categoryCodes: categories } : {},
        })
    }

    return (
        <Form
            initialValues={{
                ...searchState?.title ? { name: searchState?.title } : {}
            }}
            className="custom-form"
            name="register"
            form={form}
            colon={false}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            style={{ background: 'white', padding: 15, borderRadius: 15 }}
        >
            <div className="font-size-16 font-bold">Nhóm tài sản</div>
            <Row style={{ marginTop: 5, maxHeight: seeMore ? '100%' : '300px', overflow: 'hidden' }} gutter={[0, 15]}>
                {response.data?.content.map(item => {
                    return (<Col span={24} key={item.categoryId}>
                        <div
                            className={categories.includes(item.productCategoryCode) ? "filter-button active" : "filter-button"}
                            onClick={() => selectProduct(item.productCategoryCode)}
                        >
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {item.name.trim() || "-"}
                            </span>
                        </div>
                    </Col>
                    )
                })}
            </Row>

            <Row style={{ marginTop: 5 }} gutter={[0, 15]}>
                <Col span={24}>
                    {response.data?.totalElements && response.data?.totalElements > 5 && !seeMore ?
                        <div className="see-more-productGroup" onClick={() => setSeeMore(true)}>
                            <span>Xem thêm</span>
                            <Expand style={{ height: 20, color: 'black', marginLeft: 10 }} />
                        </div> : <></>}
                    {response.data?.totalElements && response.data?.totalElements > 5 && seeMore ?
                        <div className="see-more-productGroup" onClick={() => setSeeMore(false)}>
                            <span>Rút gọn</span>
                            <Expand style={{ height: 20, color: 'black', marginLeft: 10, transform: 'rotate(180deg)' }} />
                        </div> : <></>}
                </Col>
            </Row>
            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Giá khởi điểm (VNĐ)</div>
            <Row style={{ marginTop: 5 }} gutter={[0, 15]}>
                <Col span={24}>
                    <div
                        className={activeButton !== 1 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(0, 100000000, 1)}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 0
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 100 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={activeButton !== 2 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(100000000, 500000000, 2)}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 100 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 500 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={activeButton !== 3 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(500000000, 1000000000, 3)}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 500 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 01 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={activeButton !== 4 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 10000000000, 4)} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 01 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 10 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={activeButton !== 5 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 50000000000, 5)} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 10 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 50 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={activeButton !== 6 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(50000000000, -1, 6)} >
                        Từ trên 50 tỷ
                    </div>
                </Col>
            </Row>
            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Thời gian đấu giá</div>
            <Row style={{ marginTop: 5 }} gutter={10}>
                <Col span={12}>
                    <Form.Item
                        name="fromDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker label="" placeholder="Từ ngày" className="filter-picker" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="toDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker
                            label=""
                            placeholder="Đến ngày"
                            className="filter-picker"
                            disabledDate={(current) => {
                                return current && current < form.getFieldValue("fromDate")
                            }} />
                    </Form.Item>
                </Col>
            </Row>
            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Tên tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="name"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập tên tài sản cần tìm" className="filter-input" maxLength={200} allowClear />
                    </Form.Item>
                </Col>
            </Row>
            <Row style={{ marginTop: 30 }} align="middle" gutter={10}>
                <Col span={12}>
                    <Button className="button-gray" style={{ height: 45 }} block onClick={onReset}>NHẬP LẠI</Button>
                </Col>
                <Col span={12}>
                    <Button className="button-light-yellow" style={{ height: 45 }} block htmlType="submit">TÌM KIẾM</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default AuctionFilter;